export default __webpack_public_path__ + "images/DA.d412b97.png";